<div class="col-24">
    <h2>Filter</h2>
    @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
        <mat-form-field class="w-100">
            <mat-select
                #type="ngModel"
                (selectionChange)="inputChanged()"
                [(ngModel)]="filter.workareaType"
                name="type"
                placeholder="Soort werkvak">
                <mat-option selected value="">Werkvakken en boringen</mat-option>
                <mat-option value="Werkvakken">Werkvakken</mat-option>
                <mat-option value="Asfaltboringen">Asfaltboringen</mat-option>
            </mat-select>
        </mat-form-field>
    }
    <mat-form-field class="w-100">
        <mat-select
            #type="ngModel"
            (selectionChange)="inputChanged()"
            [(ngModel)]="filter.project"
            name="project"
            placeholder="Project">
            <mat-option [value]="null" selected>Alle projecten</mat-option>
            @for (project of filteredProjects; track project) {
                <mat-option [value]="project.id">{{ project.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-select
            #type="ngModel"
            (selectionChange)="inputChanged()"
            [(ngModel)]="filter.statuses"
            name="statuses"
            multiple
            placeholder="Status werkvak">
            @for (status of statuses; track status) {
                <mat-option [value]="status.id">{{ status.name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
        <mat-form-field class="w-100">
            <mat-select
                #type="ngModel"
                (selectionChange)="inputChanged()"
                [(ngModel)]="filter.damage"
                name="type"
                placeholder="Type">
                <mat-option [value]="null" selected>Alle types</mat-option>
                @for (type of fieldOptions['damage']; track type) {
                    <mat-option [value]="type">{{ type }} </mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
    <div>
        @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
            <mat-form-field class="w-100">
                <mat-select
                    #type="ngModel"
                    (selectionChange)="inputChanged()"
                    [(ngModel)]="filter.klinkerfloor"
                    name="type"
                    placeholder="Klinkervak">
                    <mat-option [value]="null" selected>Beide</mat-option>
                    <mat-option [value]="true">Ja</mat-option>
                    <mat-option [value]="false">Nee</mat-option>
                </mat-select>
            </mat-form-field>
        }
    </div>
    @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
        <h6 class="mb-0">Vierkante meters</h6>
        <div class="row">
            <div class="col-12">
                <mat-form-field class="spacer" style="overflow: hidden">
                    <input
                        (change)="inputChanged()"
                        [(ngModel)]="filter.min"
                        matInput
                        placeholder="Min (m2)"
                        type="text" />
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="spacer" style="overflow: hidden">
                    <input
                        (change)="inputChanged()"
                        [(ngModel)]="filter.max"
                        matInput
                        placeholder="Max (m2)"
                        type="text" />
                </mat-form-field>
            </div>
        </div>
    }
    <h6 class="mb-1">
        Werkvak aangemaakt
        <small (click)="filter.startDate = filter.endDate = null; inputChanged()" class="underline">Reset</small>
    </h6>
    <div class="row">
        <div class="col-12">
            <mat-form-field (click)="pickerStart.open()" class="w-100">
                <mat-label>Vanaf</mat-label>
                <input
                    (dateChange)="inputChanged()"
                    [(ngModel)]="filter.startDate"
                    [matDatepicker]="pickerStart"
                    matInput />
                <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-12">
            <mat-form-field (click)="picker.open()" class="w-100">
                <mat-label>Tot</mat-label>
                <input (dateChange)="inputChanged()" [(ngModel)]="filter.endDate" [matDatepicker]="picker" matInput />
                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
        <mat-form-field class="w-100">
            <mat-select
                (selectionChange)="inputChanged()"
                [(ngModel)]="filter.toplayer"
                name="toplayer"
                placeholder="Toplaag">
                <mat-option [value]="null" selected>Alle materialen</mat-option>
                @for (item of fieldOptions['toplayer']; track item) {
                    <mat-option [value]="item">
                        {{ item }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-select
                (selectionChange)="inputChanged()"
                [(ngModel)]="filter.interlayer"
                name="interlayer"
                placeholder="Tussenlaag">
                <mat-option [value]="null" selected>Alle materialen</mat-option>
                @for (item of fieldOptions['interlayer']; track item) {
                    <mat-option [value]="item">
                        {{ item }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-select
                (selectionChange)="inputChanged()"
                [(ngModel)]="filter.bottomlayer"
                name="bottomlayer"
                placeholder="Onderlaag">
                <mat-option [value]="null" selected>Alle materialen</mat-option>
                @for (item of fieldOptions['bottomlayer']; track item) {
                    <mat-option [value]="item">
                        {{ item }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    }

    <mat-form-field class="w-100">
        <mat-select
            (selectionChange)="inputChanged()"
            [(ngModel)]="filter.waymark"
            name="waymark"
            placeholder="Wegmarkering">
            <mat-option [value]="null" selected>Niet filteren op markeringen</mat-option>
            <mat-option value="all">Met markering</mat-option>
            @for (item of fieldOptions['waymark']; track item) {
                <mat-option [value]="item">
                    {{ item }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    @if ([Functionalities.GeoRead, Functionalities.GeoManage] | hasFunctionality) {
        <mat-form-field class="w-100">
            <mat-select
                (selectionChange)="inputChanged()"
                [(ngModel)]="filter.genpriority"
                name="genpriority"
                placeholder="Prioriteit">
                <mat-option [value]="null" selected>Alle prioriteiten</mat-option>
                @for (item of fieldOptions['genpriority']; track item) {
                    <mat-option [value]="item">
                        {{ item }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    }

    <mat-form-field class="w-100">
        <mat-select
            (selectionChange)="inputChanged()"
            [(ngModel)]="filter.execution"
            name="execution"
            placeholder="Uitvoering">
            <mat-option [value]="null" selected>Alle uitvoeringen</mat-option>
            @for (item of fieldOptions['execution']; track item) {
                <mat-option [value]="item">
                    {{ item }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-select
            (selectionChange)="inputChanged()"
            [(ngModel)]="filter.wearlayer"
            name="wearlayer"
            placeholder="Slijtlaag">
            <mat-option [value]="null" selected>Alle slijtlagen</mat-option>
            @for (item of fieldOptions['wearlayer']; track item) {
                <mat-option [value]="item">
                    {{ item }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <button (click)="resetFilter()" class="w-50" color="primary" mat-button>Filter resetten</button>
    <button (click)="applyFilterButton()" class="w-50" color="primary" mat-raised-button>Filter toepassen</button>
</div>
<br /><br />
